import { useState } from 'react';
import { CampaignOverviewMetrics } from '../components/CampaignOverviewMetrics/CampaignOverviewMetrics';
import { useAgencyCampaignContext } from '../agencyCampaignContext';
import { useAgencyQuery } from '../../supply/agency/hooks';
import { AgencyDialog } from '../../supply/agency/components/AgencyDialog/AgencyDialog';
import { useShigoPermissions } from '../../auth/useShigoPermissions';
import { ShigoPermission } from '../../auth/permissions';
import { CampaignDetailsLayout } from '../CampaignDetailsLayout/CampaignDetailsLayout';
import { campaignListLink } from '../hierarchyLinks';
import { BrandsTable } from '../brands/components/BrandsTable';

export function AgencyDetailsPage({ agencyId }: { agencyId: string }) {
  const scope = useAgencyCampaignContext();
  const query = useAgencyQuery(scope ? '' : agencyId);
  const agency = scope?.agency ?? query.data;
  const { can } = useShigoPermissions();
  const [editOpen, setEditOpen] = useState(false);
  const canEdit = !scope && can(ShigoPermission.SupplyWrite);
  return (
    <>
      <CampaignDetailsLayout
        name={agency?.name}
        loading={!scope && query.isLoading}
        error={!agency || (!scope && query.isError)}
        back={campaignListLink(scope?.agency.id)}
        onEdit={
          canEdit
            ? () => {
                setEditOpen(true);
              }
            : undefined
        }
      >
        {agency ? (
          <>
            <CampaignOverviewMetrics filter={{ agencyIds: [agency.id] }} />
            <BrandsTable key={agency.id} parentAgency={agency} />
          </>
        ) : null}
      </CampaignDetailsLayout>
      {canEdit && editOpen && query.data ? (
        <AgencyDialog
          agency={query.data}
          onClose={() => {
            setEditOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
